import { render } from "./ComputerList.vue?vue&type=template&id=6ba6f8de"
import script from "./ComputerList.vue?vue&type=script&lang=js"
export * from "./ComputerList.vue?vue&type=script&lang=js"

import "./ComputerList.vue?vue&type=style&index=0&id=6ba6f8de&lang=css"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__